module.exports = __webpack_public_path__ + "static/media/line.2c059545.jpg";